// source: acompanha/app_notifications/v1/app_notifications.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.app_notifications.v1.AppNotification', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.CreateAppNotificationRequest', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.CreateAppNotificationResponse', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.GetUnreadCountRequest', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.GetUnreadCountResponse', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.ListAppNotificationsRequest', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.ListAppNotificationsResponse', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest', null, global);
goog.exportSymbol('proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.AppNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.app_notifications.v1.AppNotification.repeatedFields_, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.AppNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.AppNotification.displayName = 'proto.acompanha.app_notifications.v1.AppNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.ListAppNotificationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.displayName = 'proto.acompanha.app_notifications.v1.ListAppNotificationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.ListAppNotificationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.displayName = 'proto.acompanha.app_notifications.v1.ListAppNotificationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.displayName = 'proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.displayName = 'proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.GetUnreadCountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.GetUnreadCountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.GetUnreadCountRequest.displayName = 'proto.acompanha.app_notifications.v1.GetUnreadCountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.GetUnreadCountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.GetUnreadCountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.GetUnreadCountResponse.displayName = 'proto.acompanha.app_notifications.v1.GetUnreadCountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.CreateAppNotificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.displayName = 'proto.acompanha.app_notifications.v1.CreateAppNotificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.CreateAppNotificationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.displayName = 'proto.acompanha.app_notifications.v1.CreateAppNotificationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.displayName = 'proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest.displayName = 'proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest.displayName = 'proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.displayName = 'proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.app_notifications.v1.AppNotification.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.AppNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.AppNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.AppNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
body: jspb.Message.getFieldWithDefault(msg, 3, ""),
link: jspb.Message.getFieldWithDefault(msg, 4, ""),
broadcast: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
read: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
targetUserUuid: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
targetPlanNamesList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
targetUserName: jspb.Message.getFieldWithDefault(msg, 10, ""),
targetUserEmail: jspb.Message.getFieldWithDefault(msg, 11, ""),
audience: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.AppNotification}
 */
proto.acompanha.app_notifications.v1.AppNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.AppNotification;
  return proto.acompanha.app_notifications.v1.AppNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.AppNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.AppNotification}
 */
proto.acompanha.app_notifications.v1.AppNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBroadcast(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRead(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetUserUuid(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addTargetPlanNames(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetUserName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetUserEmail(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudience(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.AppNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.AppNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.AppNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLink();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBroadcast();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getRead();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getTargetUserUuid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTargetPlanNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getTargetUserName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTargetUserEmail();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAudience();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string body = 3;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string link = 4;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setLink = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool broadcast = 5;
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getBroadcast = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setBroadcast = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool read = 6;
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getRead = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setRead = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string target_user_uuid = 7;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getTargetUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setTargetUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
*/
proto.acompanha.app_notifications.v1.AppNotification.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated string target_plan_names = 9;
 * @return {!Array<string>}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getTargetPlanNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setTargetPlanNamesList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.addTargetPlanNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.clearTargetPlanNamesList = function() {
  return this.setTargetPlanNamesList([]);
};


/**
 * optional string target_user_name = 10;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getTargetUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setTargetUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string target_user_email = 11;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getTargetUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setTargetUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string audience = 12;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.getAudience = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.AppNotification} returns this
 */
proto.acompanha.app_notifications.v1.AppNotification.prototype.setAudience = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
unreadOnly: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.ListAppNotificationsRequest;
  return proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnreadOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getUnreadOnly();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest} returns this
*/
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest} returns this
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool unread_only = 2;
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.prototype.getUnreadOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest} returns this
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsRequest.prototype.setUnreadOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notificationsList: jspb.Message.toObjectList(msg.getNotificationsList(),
    proto.acompanha.app_notifications.v1.AppNotification.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.ListAppNotificationsResponse;
  return proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.app_notifications.v1.AppNotification;
      reader.readMessage(value,proto.acompanha.app_notifications.v1.AppNotification.deserializeBinaryFromReader);
      msg.addNotifications(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotificationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.app_notifications.v1.AppNotification.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AppNotification notifications = 1;
 * @return {!Array<!proto.acompanha.app_notifications.v1.AppNotification>}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.prototype.getNotificationsList = function() {
  return /** @type{!Array<!proto.acompanha.app_notifications.v1.AppNotification>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.app_notifications.v1.AppNotification, 1));
};


/**
 * @param {!Array<!proto.acompanha.app_notifications.v1.AppNotification>} value
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse} returns this
*/
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.prototype.setNotificationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.app_notifications.v1.AppNotification=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.app_notifications.v1.AppNotification}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.prototype.addNotifications = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.app_notifications.v1.AppNotification, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse} returns this
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.prototype.clearNotificationsList = function() {
  return this.setNotificationsList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse} returns this
*/
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse} returns this
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
search: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest;
  return proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest} returns this
*/
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest} returns this
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string search = 2;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest} returns this
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notificationsList: jspb.Message.toObjectList(msg.getNotificationsList(),
    proto.acompanha.app_notifications.v1.AppNotification.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse;
  return proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.app_notifications.v1.AppNotification;
      reader.readMessage(value,proto.acompanha.app_notifications.v1.AppNotification.deserializeBinaryFromReader);
      msg.addNotifications(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotificationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.app_notifications.v1.AppNotification.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AppNotification notifications = 1;
 * @return {!Array<!proto.acompanha.app_notifications.v1.AppNotification>}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.prototype.getNotificationsList = function() {
  return /** @type{!Array<!proto.acompanha.app_notifications.v1.AppNotification>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.app_notifications.v1.AppNotification, 1));
};


/**
 * @param {!Array<!proto.acompanha.app_notifications.v1.AppNotification>} value
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse} returns this
*/
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.prototype.setNotificationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.app_notifications.v1.AppNotification=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.app_notifications.v1.AppNotification}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.prototype.addNotifications = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.app_notifications.v1.AppNotification, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse} returns this
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.prototype.clearNotificationsList = function() {
  return this.setNotificationsList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse} returns this
*/
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse} returns this
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.GetUnreadCountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.GetUnreadCountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.GetUnreadCountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.GetUnreadCountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.GetUnreadCountRequest}
 */
proto.acompanha.app_notifications.v1.GetUnreadCountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.GetUnreadCountRequest;
  return proto.acompanha.app_notifications.v1.GetUnreadCountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.GetUnreadCountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.GetUnreadCountRequest}
 */
proto.acompanha.app_notifications.v1.GetUnreadCountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.GetUnreadCountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.GetUnreadCountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.GetUnreadCountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.GetUnreadCountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.GetUnreadCountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.GetUnreadCountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.GetUnreadCountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.GetUnreadCountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
unreadCount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.GetUnreadCountResponse}
 */
proto.acompanha.app_notifications.v1.GetUnreadCountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.GetUnreadCountResponse;
  return proto.acompanha.app_notifications.v1.GetUnreadCountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.GetUnreadCountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.GetUnreadCountResponse}
 */
proto.acompanha.app_notifications.v1.GetUnreadCountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnreadCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.GetUnreadCountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.GetUnreadCountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.GetUnreadCountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.GetUnreadCountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnreadCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 unread_count = 1;
 * @return {number}
 */
proto.acompanha.app_notifications.v1.GetUnreadCountResponse.prototype.getUnreadCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.app_notifications.v1.GetUnreadCountResponse} returns this
 */
proto.acompanha.app_notifications.v1.GetUnreadCountResponse.prototype.setUnreadCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
body: jspb.Message.getFieldWithDefault(msg, 2, ""),
link: jspb.Message.getFieldWithDefault(msg, 3, ""),
broadcast: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
targetUserUuid: jspb.Message.getFieldWithDefault(msg, 5, ""),
targetPlanNamesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
notifyImmediately: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.CreateAppNotificationRequest;
  return proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBroadcast(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetUserUuid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addTargetPlanNames(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNotifyImmediately(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLink();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBroadcast();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTargetUserUuid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTargetPlanNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getNotifyImmediately();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} returns this
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string body = 2;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} returns this
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string link = 3;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} returns this
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.setLink = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool broadcast = 4;
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.getBroadcast = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} returns this
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.setBroadcast = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string target_user_uuid = 5;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.getTargetUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} returns this
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.setTargetUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated string target_plan_names = 6;
 * @return {!Array<string>}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.getTargetPlanNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} returns this
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.setTargetPlanNamesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} returns this
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.addTargetPlanNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} returns this
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.clearTargetPlanNamesList = function() {
  return this.setTargetPlanNamesList([]);
};


/**
 * optional bool notify_immediately = 7;
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.getNotifyImmediately = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} returns this
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationRequest.prototype.setNotifyImmediately = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.CreateAppNotificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notification: (f = msg.getNotification()) && proto.acompanha.app_notifications.v1.AppNotification.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationResponse}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.CreateAppNotificationResponse;
  return proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.CreateAppNotificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationResponse}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.app_notifications.v1.AppNotification;
      reader.readMessage(value,proto.acompanha.app_notifications.v1.AppNotification.deserializeBinaryFromReader);
      msg.setNotification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.CreateAppNotificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotification();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.app_notifications.v1.AppNotification.serializeBinaryToWriter
    );
  }
};


/**
 * optional AppNotification notification = 1;
 * @return {?proto.acompanha.app_notifications.v1.AppNotification}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.prototype.getNotification = function() {
  return /** @type{?proto.acompanha.app_notifications.v1.AppNotification} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.app_notifications.v1.AppNotification, 1));
};


/**
 * @param {?proto.acompanha.app_notifications.v1.AppNotification|undefined} value
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationResponse} returns this
*/
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.prototype.setNotification = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.app_notifications.v1.CreateAppNotificationResponse} returns this
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.prototype.clearNotification = function() {
  return this.setNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.prototype.hasNotification = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest}
 */
proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest;
  return proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest}
 */
proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest} returns this
 */
proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest}
 */
proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest;
  return proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest}
 */
proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest}
 */
proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest;
  return proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest}
 */
proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest}
 */
proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest;
  return proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest}
 */
proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest} returns this
 */
proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.app_notifications.v1);
